import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import "./css/basic.css";
import LoginPage from "./pages/login-page";
import RedFishPage from "./pages/redfish";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/redfish/v1/*" element={<RedFishPage />} />
          <Route path="/" element={<LoginPage />} exact />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
